
    var overlay = document.querySelector('.navigation-mobile');
    var menu = document.querySelector('.navigation-mobile__menu');

    function openMobileMenu() {
        overlay.classList.add('navigation-mobile--active');
        menu.classList.add('navigation-mobile__menu--active');
    };

    function closeMobileMenu() {
        overlay.classList.remove('navigation-mobile--active');
        menu.classList.remove('navigation-mobile__menu--active');
    };

    function setFixedPosition() {
        var scrollPosition = window.pageYOffset;
        document.body.style.position = 'fixed';
        document.body.style.height = '100%';
        document.body.style.width = '100%';
        document.body.style.top = '-' + scrollPosition + 'px';
    };

    function unSetFixedPosition() {
        document.body.style.position = '';
        document.body.style.height = '';
        document.body.style.width = '';
        document.body.style.top = '';
    };



    var menuBtn = document.querySelector('.header__menu-btn');

    menuBtn.addEventListener('click', function() {
        openMobileMenu();
        setFixedPosition();
    });

    var menuCloseBtn = document.querySelector('.navigation-mobile__close');

    menuCloseBtn.addEventListener('click', function() {
        closeMobileMenu();
        unSetFixedPosition();
    });

    overlay.addEventListener('click', function(event) {
        isClickable = menu.contains(event.target);

        if(!isClickable) {
            closeMobileMenu();
            unSetFixedPosition();
        }
        
    });

    var navDropdown = document.querySelectorAll('[data-dropdown]');

    navDropdown.forEach(function(el) {
        var hoveredNav = el.dataset.dropdown;
        var selectedDoprdown = document.getElementById('navigation-dropdown--' + hoveredNav);

        el.addEventListener('mouseover', function() {
            selectedDoprdown.classList.add('navigation-dropdown--show');
        });
    
        el.addEventListener('mouseleave', function() {
            selectedDoprdown.classList.remove('navigation-dropdown--show');
        })
    });

    var navMobileDropdown = document.querySelectorAll('[data-mobile-dropdown]');

    navMobileDropdown.forEach(function(el) {
        var selectedMobileNav = el.dataset.mobileDropdown;
        var selectedDropdown = document.getElementById('navigation-mobile-dropdown--' + selectedMobileNav);

        el.addEventListener('click', function(){
            var chevron = document.getElementById('mobileNavChildIcon--' + selectedMobileNav);
            chevron.classList.toggle('navigation-mobile__btn-icon-down--active');
            selectedDropdown.classList.toggle('navigation-mobile-dropdown--show');
        })
    })


// if( document.readyState !== 'loading' ) {
//     navigationInit();
// } else {
//     document.addEventListener("DOMContentLoaded", function(){
//         navigationInit();
//     });
// }



